import React from 'react'

import { EmptyFileUpload } from 'v2/ui/svgs/EmptyFileUpload'

import { Box, BoxProps } from 'ui/components/Box'
import { Body } from 'ui/components/Text'

import { useFileUploadDropzoneState } from './hooks/useFileUploadDropzoneState'
import { FileUploadTrigger } from './FileUploadTrigger'

import { FileUploadDropzoneIconStyle, FileUploadDropzoneStyle } from './FileUpload.css'

type FileUploadDropzoneProps = BoxProps & {}

export const FileUploadDropzone: React.FC<FileUploadDropzoneProps> = ({
    onClick: onClickProp,
    onDragOver: onDragOverProp,
    onDragEnter: onDragEnterProp,
    onDragLeave: onDragLeaveProp,
    onDrop: onDropProp,
    onPaste: onPasteProp,
    onKeyDown: onKeyDownProp,
    ...props
}) => {
    const {
        onClick,
        onDragOver,
        onDragEnter,
        onDragLeave,
        onDrop,
        onPaste,
        onKeyDown,
        dropzoneId,
        inputId,
        listId,
        disabled,
        isDraggingOver,
    } = useFileUploadDropzoneState({
        onClickProp,
        onDragOverProp,
        onDragEnterProp,
        onDragLeaveProp,
        onDropProp,
        onPasteProp,
        onKeyDownProp,
    })

    return (
        <Box
            {...props}
            role="region"
            id={dropzoneId}
            aria-controls={`${inputId} ${listId}`}
            aria-disabled={disabled}
            data-disabled={disabled ? '' : undefined}
            data-dragging={isDraggingOver ? '' : undefined}
            tabIndex={disabled ? undefined : 0}
            onClick={onClick}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={onDragOver}
            onDrop={onDrop}
            onKeyDown={onKeyDown}
            onPaste={onPaste}
            className={FileUploadDropzoneStyle}
        >
            <Box>
                <EmptyFileUpload className={FileUploadDropzoneIconStyle} />
            </Box>
            <Box flex column gap="xs">
                <Body color={disabled ? 'textDisabled' : 'text'} weight="bold" size="l">
                    Drag your files here
                </Body>
                <Body color={disabled ? 'textDisabled' : 'textWeaker'} weight="regular" size="m">
                    or click to upload
                </Body>
            </Box>
            <FileUploadTrigger />
        </Box>
    )
}
